const ns = "INTEGRATION_EVENTBRITE_ORDERS_RESYNC";
export const RESYNC = `${ns}_RESYNC`;
export const RESYNC_COMPLETE = `${ns}_RESYNC_COMPLETE`;
export const ERROR = `${ns}_ERROR`;
